import styled from "styled-components";

export const PrivilegeDetailContainerStyled = styled.div`
  padding: 32px 20px 40px 20px;
`;
